// extracted by mini-css-extract-plugin
export default {"badge":"DBadge_badge__Sc4Qc","dday":"DBadge_dday__5-Afx","urgent":"DBadge_urgent__eeOcQ","closed":"DBadge_closed__hAtqZ"};